import React from 'react';
import { IconColor, IconProps } from './types';
import { StyledIcon } from './styled';

export { IconColor };

export const Icon: React.FC<IconProps> = ({
  IconComponent,
  width = 15,
  height = 15,
  color = IconColor.blue,
  indent = true,
  lgIndent = false,
  pathColor,
  iconNeedColorChange = false,
  onClick,
  dataCypress
}) => {
  if (!IconComponent) return null;

  return (
    <StyledIcon
      IconComponent={IconComponent}
      $color={color as IconColor}
      $indent={indent}
      $lgIndent={lgIndent}
      $pathColor={pathColor as IconColor}
      $iconNeedColorChange={iconNeedColorChange}
      width={width || undefined}
      height={height || undefined}
      data-cy={dataCypress || `svg-icon--${color}`}
      onClick={onClick}
    />
  );
};
